// @flow
import { StaffActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    empleado: {},
    listaEmpleados: [],
    loading: false,
    loadingList: false,
    error: false,
    errorList: false,
    formSubmited: false
};

type StaffAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { empleado?: {} | null, listaEmpleados?: [] | null, loading?: boolean, +value ?: boolean };

const Staff = (state: State = INIT_STATE, action: StaffAction): any => {
    // console.log(action);
    switch (action.type) {
        case StaffActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case StaffActionTypes.GET_EMPLOYEE: {
                    return {
                        ...state,
                        empleado: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: false
                    };
                }
                case StaffActionTypes.LIST_EMPLOYEES: {
                    return {
                        ...state,
                        listaEmpleados: action.payload.data,
                        errorList: false,
                        loadingList: false,
                        formSubmited: false
                    };
                }
                case StaffActionTypes.ADD_EMPLOYEE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case StaffActionTypes.UPDATE_EMPLOYEE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        // usuario: action.payload.data,
                        formSubmited: true
                    };
                }
                case StaffActionTypes.DELETE_EMPLOYEE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case StaffActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case StaffActionTypes.GET_EMPLOYEE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        empleado: {},
                        loading: false,
                        formSubmited: false
                    };
                }
                case StaffActionTypes.LIST_EMPLOYEES: {
                    return {
                        ...state,
                        errorList: true,
                        listaEmpleados: [],
                        loadingList: false,
                        formSubmited: false
                    };
                }
                case StaffActionTypes.ADD_EMPLOYEE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case StaffActionTypes.UPDATE_EMPLOYEE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case StaffActionTypes.DELETE_EMPLOYEE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case StaffActionTypes.GET_EMPLOYEE:
            return { ...state, error: false, loading: true };
        case StaffActionTypes.LIST_EMPLOYEES:
            return { ...state, errorList: false, loadingList: true };
        case StaffActionTypes.ADD_EMPLOYEE:
            return { ...state, error: false, loading: false };
        case StaffActionTypes.UPDATE_EMPLOYEE:
            return { ...state, error: false, loading: false };
        case StaffActionTypes.DELETE_EMPLOYEE:
            return { ...state, error: false, loading: false };
        case StaffActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                loadingList: false,
                errorList: false,
                empleado: {},
                listaEmpleados: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Staff;
